import ReactTooltip from 'react-tooltip';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';

export const StyledMapTooltip = styled(ReactTooltip)(({ theme }) => ({
  fontWeight: 500,
  // unfortunately !important is recommended way to override styles from react-tooltip
  background: `${alpha(theme.palette.grey[900], 0.9)} !important`,
  borderRadius: '6px !important',
  fontSize: '1.5rem !important',
  padding: `${theme.spacing(2)} ${theme.spacing(4)} !important`,
  zIndex: '1201 !important',
  maxWidth: '300px !important',
}));
